import Hotjar from '@hotjar/browser';

import { useEffect } from 'react';
import {
  isB2BUser,
  isEduUser,
  isMonthlyActiveOrCancelledUser,
  isYearlyActiveOrCancelledUser,
} from 'src/common/helpers/subscription';
import { useGetUserQuery } from 'src/common/slices';

export const HOTJAR_POLL_INTERVAL_MS = 1000;
export const HOTJAR_POLL_TIMEOUT_MS = 5_000;

export const useHotjarIdentify = () => {
  const { data: userData } = useGetUserQuery();

  useEffect(() => {
    const user = userData?.data?.user;
    if (!user) return;

    const tryIdentify = () => {
      if (!Hotjar.isReady()) return false;

      return Hotjar.identify(user._id, {
        ...(user.demographics.experience && { experience: user.demographics.experience }),
        isPremium: user.isPremium,
        dateSignUp: user.dateSignUp,
        displayName: user.username,
        countryCode: user.local.country,
        monthlySubscriber: isMonthlyActiveOrCancelledUser(user),
        yearlySubscriber: isYearlyActiveOrCancelledUser(user),
        isB2B: isB2BUser(user),
        isEdu: isEduUser(user),
      });
    };

    const startTime = Date.now();

    const interval = setInterval(() => {
      const timedOut = Date.now() - startTime >= HOTJAR_POLL_TIMEOUT_MS;
      if (tryIdentify() || timedOut) {
        if (timedOut) console.warn('Hotjar identify failed');
        clearInterval(interval);
      }
    }, HOTJAR_POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [userData?.data?.user]);
};
